// extracted by mini-css-extract-plugin
var _1 = "MainTrainerContainer__bg--oVbQS TopGeneral__bgBlue--OVmWv TopGeneral__bg--z7KIw TopGeneral__bgSize--LtApb";
var _2 = "MainTrainerContainer__content--ppCib";
var _3 = "MainTrainerContainer__copyright--pT7PR CoreGeneral__robotoSlab--X8lgW";
var _4 = "MainTrainerContainer__jazz--hbmkF";
var _5 = "MainTrainerContainer__main--rJET0";
export { _1 as "bg", _2 as "content", _3 as "copyright", _4 as "jazz", _5 as "main" }
